import * as seekerProfileActions from "./actions"

import { all, call, put, take, takeEvery } from "redux-saga/effects"
import {
  deleteProfileEducation,
  deleteProfileExperience,
  deleteProfileLanguage,
  deleteSkillset,
  getProfile,
  getProfileAssessment,
  getSkills,
  patchProfile,
  postProfileAssessment,
  postProfileEducation,
  postProfileExperience,
  postProfileLanguages,
  postProfileSkillsets,
  updateProfileEducation,
  updateProfileExperience,
  updateProfileLanguage,
  updateProfileSkillset,
  postProfileReference,
  deleteReference,
  updateReference,
  postProfileCertificate,
  updateCertificate,
  deleteCertificate,
  postAttachment,
  updateAttachment,
  deleteAttachment
} from "@src/services/apis"

import { SEEKER_PROFILE_TYPES } from "./types"

function* getProfileRequest(action) {
  try {
    const response = yield call(getProfile, action.payload)
    yield put(seekerProfileActions.getProfileSuccess(response.data))
  } catch (err) {
    yield put(seekerProfileActions.getProfileFailure(err))
  }
}

function* getSkillsRequest() {
  try {
    const response = yield call(getSkills)
    yield put(seekerProfileActions.getSkillsSuccess(response.data))
  } catch (err) {
    yield put(seekerProfileActions.getSkillsFailure(err))
  }
}

function* postExperienceRequest(action) {
  try {
    const response = yield call(postProfileExperience, action.payload)
    if (response?.code === "ERR_NETWORK") {
      yield put(
        seekerProfileActions.postExperienceFailure({ message: "Network Error" })
      )
    } else if (response?.status === 200 || response.status === 201) {
      yield put(seekerProfileActions.postExperienceSuccess(response))
    } else {
      yield put(seekerProfileActions.postExperienceFailure(response))
    }
  } catch (err) {
    yield put(seekerProfileActions.postExperienceFailure(err))
  }
}

function* postLanguagesRequest(action) {
  try {
    const response = yield call(postProfileLanguages, action.payload)

    if (response?.code === "ERR_NETWORK") {
      yield put(
        seekerProfileActions.postLanguagesFailure({ message: "Network Error" })
      )
    } else if (response?.status === 200 || response.status === 201) {
      yield put(seekerProfileActions.postLanguagesSuccess(response))
    } else {
      yield put(seekerProfileActions.postLanguagesFailure(response))
    }
  } catch (err) {
    yield put(seekerProfileActions.postLanguagesFailure(err))
  }
}

function* postEducationRequest(action) {
  try {
    const response = yield call(postProfileEducation, action.payload)

    if (response?.code === "ERR_NETWORK") {
      yield put(
        seekerProfileActions.postEducationFailure({ message: "Network Error" })
      )
    } else if (response?.status === 200 || response.status === 201) {
      yield put(seekerProfileActions.postEducationSuccess(response))
    } else {
      yield put(seekerProfileActions.postEducationFailure(response))
    }
  } catch (err) {
    yield put(seekerProfileActions.postEducationFailure(err))
  }
}

function* postSkillsRequest(action) {
  try {
    const response = yield call(postProfileSkillsets, action.payload)
    if (response?.code === "ERR_NETWORK") {
      yield put(
        seekerProfileActions.postSkillsFailure({ message: "Network Error" })
      )
    } else if (response?.status === 200 || response.status === 201) {
      yield put(seekerProfileActions.postSkillsSuccess(response))
    } else {
      yield put(seekerProfileActions.postSkillsFailure(response))
    }
  } catch (err) {
    yield put(seekerProfileActions.postSkillsFailure(err))
  }
}

function* postReferencesRequest(action) {
  try {
    const response = yield call(postProfileReference, action.payload)
    if (response?.code === "ERR_NETWORK") {
      yield put(
        seekerProfileActions.postReferenceFailure({ message: "Network Error" })
      )
    } else if (response?.status === 200 || response.status === 201) {
      yield put(seekerProfileActions.postReferenceSuccess(response))
    } else {
      yield put(seekerProfileActions.postReferenceFailure(response))
    }
  } catch (err) {
    yield put(seekerProfileActions.postReferenceFailure(err))
  }
}

// delete skills
function* deleteSkillsRequest(action) {
  try {
    const response = yield call(deleteSkillset, action.payload)
    if (response?.code === "ERR_NETWORK") {
      yield put(
        seekerProfileActions.deleteSkillsFailure({ message: "Network Error" })
      )
    } else if (response?.status === 200 || response.status === 201) {
      yield put(seekerProfileActions.deleteSkillsSuccess(response))
    } else {
      yield put(seekerProfileActions.deleteSkillsFailure(response))
    }
  } catch (err) {
    yield put(seekerProfileActions.deleteSkillsFailure(err))
  }
}

function* deleteReferenceRequest(action) {
  try {
    const response = yield call(deleteReference, action.payload)
    if (response?.code === "ERR_NETWORK") {
      yield put(
        seekerProfileActions.deleteReferenceFailure({
          message: "Network Error"
        })
      )
    } else if (response?.status === 200 || response.status === 201) {
      yield put(seekerProfileActions.deleteReferenceSuccess(response))
    } else {
      yield put(seekerProfileActions.deleteReferenceFailure(response))
    }
  } catch (err) {
    yield put(seekerProfileActions.deleteReferenceFailure(err))
  }
}

function* updateReferenceRequest(action) {
  try {
    const response = yield call(updateReference, action.payload)
    if (response?.code === "ERR_NETWORK") {
      yield put(
        seekerProfileActions.patchReferenceFailure({ message: "Network Error" })
      )
    } else if (response?.status === 200 || response.status === 201) {
      yield put(seekerProfileActions.patchReferenceSuccess(response))
    } else {
      yield put(seekerProfileActions.patchReferenceFailure(response))
    }
  } catch (err) {
    yield put(seekerProfileActions.patchReferenceFailure(err))
  }
}

function* updateExperienceRequest(action) {
  try {
    const response = yield call(updateProfileExperience, action.payload)
    yield put(seekerProfileActions.patchExperienceSuccess(response.data))
  } catch (err) {
    yield put(seekerProfileActions.patchExperienceFailure(err))
  }
}

function* updateEducationRequest(action) {
  try {
    const response = yield call(updateProfileEducation, action.payload)
    yield put(seekerProfileActions.patchEducationSuccess(response.data))
  } catch (err) {
    yield put(seekerProfileActions.patchEducationFailure(err))
  }
}

function* updateLanguageRequest(action) {
  try {
    const response = yield call(updateProfileLanguage, action.payload)
    yield put(seekerProfileActions.patchLanguagesSuccess(response.data))
  } catch (err) {
    yield put(seekerProfileActions.patchLanguagesFailure(err))
  }
}

function* updateSkillRequest(action) {
  try {
    const response = yield call(updateProfileSkillset, action.payload)
    yield put(seekerProfileActions.patchSkillsSuccess(response.data))
  } catch (err) {
    yield put(seekerProfileActions.patchSkillsFailure(err))
  }
}

function* patchProfileRequest(action) {
  try {
    const response = yield call(patchProfile, action.payload)
    yield put(seekerProfileActions.patchProfileSuccess(response.data))
  } catch (err) {
    yield put(seekerProfileActions.patchProfileFailure(err))
  }
}

function* deleteEducationRequest(action) {
  try {
    const response = yield call(deleteProfileEducation, action.payload)
    yield put(seekerProfileActions.deleteEducationSuccess(response.data))
  } catch (err) {
    yield put(seekerProfileActions.deleteEducationFailure(err))
  }
}

function* deleteExperienceRequest(action) {
  try {
    const response = yield call(deleteProfileExperience, action.payload)
    yield put(seekerProfileActions.deleteExperienceSuccess(response.data))
  } catch (err) {
    yield put(seekerProfileActions.deleteExperienceFailure(err))
  }
}

function* deleteLanguageRequest(action) {
  try {
    const response = yield call(deleteProfileLanguage, action.payload)
    yield put(seekerProfileActions.deleteProfileLanguagesSuccess(response.data))
  } catch (err) {
    yield put(seekerProfileActions.deleteExperienceFailure(err))
  }
}

function* postProfileCertificateRequest(action) {
  try {
    const response = yield call(postProfileCertificate, action.payload)
    if (response?.code === "ERR_NETWORK") {
      yield put(
        seekerProfileActions.postCertificateFailure({
          message: "Network Error"
        })
      )
    } else if (response?.status === 200 || response.status === 201) {
      yield put(seekerProfileActions.postCertificateSuccess(response))
    } else {
      yield put(seekerProfileActions.postCertificateFailure(response))
    }
  } catch (err) {
    yield put(seekerProfileActions.postCertificateFailure(err))
  }
}

function* updateCertificateRequest(action) {
  try {
    const response = yield call(updateCertificate, action.payload)
    if (response?.code === "ERR_NETWORK") {
      yield put(
        seekerProfileActions.patchCertificateFailure({
          message: "Network Error"
        })
      )
    } else if (response?.status === 200 || response.status === 201) {
      yield put(seekerProfileActions.patchCertificateSuccess(response))
    } else {
      yield put(seekerProfileActions.patchCertificateFailure(response))
    }
  } catch (err) {
    yield put(seekerProfileActions.patchCertificateFailure(err))
  }
}

function* deleteCertificateRequest(action) {
  try {
    const response = yield call(deleteCertificate, action.payload)
    if (response?.code === "ERR_NETWORK") {
      yield put(
        seekerProfileActions.deleteCertificateFailure({
          message: "Network Error"
        })
      )
    } else if (response?.status === 200 || response.status === 201) {
      yield put(seekerProfileActions.deleteCertificateSuccess(response))
    } else {
      yield put(seekerProfileActions.deleteCertificateFailure(response))
    }
  } catch (err) {
    yield put(seekerProfileActions.deleteCertificateFailure(err))
  }
}

function* postAttachmentRequest(action) {
  try {
    const response = yield call(postAttachment, action.payload)
    if (response?.code === "ERR_NETWORK") {
      yield put(
        seekerProfileActions.postAttachmentFailure({ message: "Network Error" })
      )
    } else if (response?.status === 200 || response.status === 201) {
      yield put(seekerProfileActions.postAttachmentSuccess(response))
    } else {
      yield put(seekerProfileActions.postAttachmentFailure(response))
    }
  } catch (err) {
    yield put(seekerProfileActions.postAttachmentFailure(err))
  }
}

function* updateAttachmentRequest(action) {
  try {
    const response = yield call(updateAttachment, action.payload)
    if (response?.code === "ERR_NETWORK") {
      yield put(
        seekerProfileActions.patchAttachmentFailure({ message: "Network Error" })
      )
    } else if (response?.status === 200 || response.status === 201) {
      yield put(seekerProfileActions.patchAttachmentSuccess(response))
    } else {
      yield put(seekerProfileActions.patchAttachmentFailure(response))
    }
  } catch (err) {
    yield put(seekerProfileActions.patchAttachmentFailure(err))
  }
}

function* deleteAttachmentRequest(action) {
  try {
    const response = yield call(deleteAttachment, action.payload)
    if (response?.code === "ERR_NETWORK") {
      yield put(
        seekerProfileActions.deleteAttachmentFailure({ message: "Network Error" })
      )
    } else if (response?.status === 200 || response.status === 201) {
      yield put(seekerProfileActions.deleteAttachmentSuccess(response))
    } else {
      yield put(seekerProfileActions.deleteAttachmentFailure(response))
    }
  } catch (err) {
    yield put(seekerProfileActions.deleteAttachmentFailure(err))
  }
}

// function* getProfileAssessmentRequest(action) {
//   try {
//     const response = yield call(getProfileAssessment, action.payload)
//     yield put(seekerProfileActions.getProfileAssessmentSuccess(response.data))
//   } catch (err) {
//     yield put(seekerProfileActions.getProfileAssessmentFailure(err))
//   }
// }

// function* postProfileAssessmentRequest(action) {
//   try {
//     const response = yield call(postProfileAssessment, action.payload)
//     yield put(seekerProfileActions.postProfileAssessmentSuccess(response.data))
//   } catch (err) {
//     yield put(seekerProfileActions.postProfileAssessmentFailure(err))
//   }
// }

// function* viewProfileAssessmentRequest(action) {
//   try {
//     const response = yield call(viewProfileAssessment, action.payload)
//     yield put(seekerProfileActions.viewProfileAssessmentSuccess(response.data))
//   } catch (err) {
//     yield put(seekerProfileActions.viewProfileAssessmentFailure(err))
//   }
// }

function* seekerProfileSaga() {
  yield all([
    takeEvery(SEEKER_PROFILE_TYPES.GET_PROFILE_REQUEST, getProfileRequest),
    takeEvery(SEEKER_PROFILE_TYPES.GET_SKILLS_REQUEST, getSkillsRequest),
    takeEvery(
      SEEKER_PROFILE_TYPES.PATCH_EXPERIENCE_REQUEST,
      updateExperienceRequest
    ),
    takeEvery(
      SEEKER_PROFILE_TYPES.PATCH_EDUCATION_REQUEST,
      updateEducationRequest
    ),
    takeEvery(
      SEEKER_PROFILE_TYPES.PATCH_LANGUAGES_REQUEST,
      updateLanguageRequest
    ),
    takeEvery(SEEKER_PROFILE_TYPES.PATCH_SKILLS_REQUEST, updateSkillRequest),
    takeEvery(
      SEEKER_PROFILE_TYPES.POST_EXPERIENCE_REQUEST,
      postExperienceRequest
    ),
    takeEvery(
      SEEKER_PROFILE_TYPES.POST_LANGUAGES_REQUEST,
      postLanguagesRequest
    ),
    takeEvery(
      SEEKER_PROFILE_TYPES.POST_EDUCATION_REQUEST,
      postEducationRequest
    ),
    takeEvery(SEEKER_PROFILE_TYPES.POST_SKILLS_REQUEST, postSkillsRequest),
    takeEvery(SEEKER_PROFILE_TYPES.DELETE_SKILLS_REQUEST, deleteSkillsRequest),
    takeEvery(SEEKER_PROFILE_TYPES.PATCH_PROFILE_REQUEST, patchProfileRequest),

    takeEvery(SEEKER_PROFILE_TYPES.POST_REFERENCE_REQUEST, postReferencesRequest),
    takeEvery(SEEKER_PROFILE_TYPES.DELETE_REFERENCE_REQUEST, deleteReferenceRequest),
    takeEvery(SEEKER_PROFILE_TYPES.PATCH_REFERENCE_REQUEST, updateReferenceRequest),

    takeEvery(SEEKER_PROFILE_TYPES.POST_ATTACHMENT_REQUEST, postAttachmentRequest),
    takeEvery(SEEKER_PROFILE_TYPES.PATCH_ATTACHMENT_REQUEST, updateAttachmentRequest),
    takeEvery(SEEKER_PROFILE_TYPES.DELETE_ATTACHMENT_REQUEST, deleteAttachmentRequest),


    takeEvery(
      SEEKER_PROFILE_TYPES.POST_CERTIFICATE_REQUEST,
      postProfileCertificateRequest
    ),
    takeEvery(
      SEEKER_PROFILE_TYPES.PATCH_CERTIFICATE_REQUEST,
      updateCertificateRequest
    ),
    takeEvery(
      SEEKER_PROFILE_TYPES.DELETE_CERTIFICATE_REQUEST,
      deleteCertificateRequest
    ),
    takeEvery(
      SEEKER_PROFILE_TYPES.DELETE_EDUCATION_REQUEST,
      deleteEducationRequest
    ),
    takeEvery(
      SEEKER_PROFILE_TYPES.DELETE_EXPERIENCE_REQUEST,
      deleteExperienceRequest
    ),
    takeEvery(
      SEEKER_PROFILE_TYPES.DELETE_PROFILE_LANGUAGES_REQUEST,
      deleteLanguageRequest
    )

    // takeEvery(
    //   SEEKER_PROFILE_TYPES.GET_PROFILE_ASSESSMENT_REQUEST,
    //   getProfileAssessmentRequest
    // ),
    // takeEvery(
    //   SEEKER_PROFILE_TYPES.POST_PROFILE_ASSESSMENT_REQUEST,
    //   postProfileAssessmentRequest
    // ),
    // takeEvery(
    //   SEEKER_PROFILE_TYPES.VIEW_PROFILE_ASSESSMENT_REQUEST,
    //   viewProfileAssessmentRequest
    // )
  ])
}

export default seekerProfileSaga
